// Loads creator fonts as opentype.js fonts (TTF served by the API) so text
// can be measured exactly and turned into vector outlines for printing.
import opentype from "opentype.js";

const cache = new Map();

export function normalizeFamily(name) {
    return String(name || "")
        .trim()
        .replace(/^['"]+|['"]+$/g, "");
}

function apiUrl() {
    return process.env.NODE_ENV === "production"
        ? `${process.env.VUE_APP_API_URL}`
        : "";
}

export function loadFont(family) {
    const key = normalizeFamily(family);
    if (!key) {
        return Promise.resolve(null);
    }
    if (!cache.has(key)) {
        const url = `${apiUrl()}/sticker/font?family=${encodeURIComponent(
            key
        )}`;
        const promise = fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Font not available: ${key}`);
                }
                return response.arrayBuffer();
            })
            .then(buffer => opentype.parse(buffer))
            .catch(() => {
                // Fall back to CSS text rendering; retry on a later request.
                cache.delete(key);
                return null;
            });
        cache.set(key, promise);
    }
    return cache.get(key);
}

// Characters of the texts that the font has no glyph for (would print as boxes).
export function missingCharacters(font, texts) {
    if (!font) {
        return [];
    }
    const chars = new Set(
        (texts || [])
            .join("")
            .replace(/\s/g, "")
            .split("")
    );
    return [...chars].filter(char => font.charToGlyph(char).index === 0);
}
